import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
    paperDialog: {
        maxWidth: "none",
        width: 450
    }
}));
